import LendiCodeManagementScreen from './LendiCodeManagementScreen';
export default LendiCodeManagementScreen;
